import { render, staticRenderFns } from "./TabConsultationsList.vue?vue&type=template&id=365aaaf7&"
import script from "./TabConsultationsList.vue?vue&type=script&lang=js&"
export * from "./TabConsultationsList.vue?vue&type=script&lang=js&"
import style0 from "./TabConsultationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports